








































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AdminListView from '@/components/admin/AdminListView.vue';
import { ApplicationRecord } from '@/api';
import { authModule } from '@/store';

@Component({
  components: {},
})
export default class extends Vue {
  item = 0;

  adminNavOpen: boolean = false;
  adminActionsOpen: boolean = false;

  get items() {
    const menuItems: any = [
      { text: 'Diary', icon: 'far fa-book-open', to: { name: 'admin-diary' } },
      { text: 'Bookings', icon: 'far fa-book', to: { name: 'admin-bookings' } },
      {
        text: 'Customers',
        icon: 'far fa-user',
        to: { name: 'admin-customers' },
      },
      { text: 'Vehicles', icon: 'far fa-car', to: { name: 'admin-vehicles' } },

      {
        text: 'Contact',
        icon: 'far fa-envelope',
        to: { name: 'admin-contact' },
      },
    ];

    if (authModule.isAdmin) {
      menuItems.push({
        text: 'Promo Codes',
        icon: 'far fa-percent',
        to: { name: 'admin-discounts' },
      });

      const reportQuery: { [key: string]: string } = {};
      if (
        this.$route.query.start_date &&
        typeof this.$route.query.start_date === 'string'
      ) {
        reportQuery.start_date = this.$route.query.start_date;
      }
      if (
        this.$route.query.end_date &&
        typeof this.$route.query.end_date === 'string'
      ) {
        reportQuery.end_date = this.$route.query.end_date;
      }
      menuItems.push({
        text: 'Reports',
        icon: 'far fa-chart-bar',
        children: [
          {
            text: 'Overview',
            icon: 'far fa-analytics',
            to: { name: 'admin-reports', query: reportQuery },
          },
          {
            text: 'Departing/Returning',
            icon: 'far fa-chart-bar',
            to: { name: 'admin-reports-inout', query: reportQuery },
          },
          {
            text: 'Extras',
            icon: 'far fa-table',
            to: { name: 'admin-reports-extras', query: reportQuery },
          },
          {
            text: 'Imports & Reconciliation',
            icon: 'far fa-credit-card',
            to: { name: 'admin-imports' },
          },
        ],
      });

      menuItems.push({
        text: 'Settings',
        icon: 'far fa-cog',
        children: [
          { text: 'Lots', icon: 'far fa-square', to: { name: 'admin-lots' } },
          {
            text: 'Airlines',
            icon: 'far fa-plane',
            to: { name: 'admin-airlines' },
          },
          {
            text: 'Flights',
            icon: 'far fa-plane-departure',
            to: { name: 'admin-flights' },
          },
          { text: 'Buses', icon: 'far fa-bus', to: { name: 'admin-bustrips' } },
          {
            text: 'Vehicle Types',
            icon: 'far fa-car-side',
            to: { name: 'admin-vehicletypes' },
          },
          {
            text: 'Extras',
            icon: 'far fa-plus-circle',
            to: { name: 'admin-extras' },
          },
          {
            text: 'Rates',
            icon: 'far fa-dollar-sign',
            to: { name: 'admin-rates' },
          },
          {
            text: 'Pricing/Availability',
            icon: 'far fa-calendar-star',
            to: { name: 'admin-days' },
          },
          {
            text: 'Blockout Periods',
            icon: 'far fa-calendar',
            to: { name: 'admin-blockout-periods' },
          }
        ],
      });
    }

    return menuItems;
  }

  get currentUser() {
    if (authModule.user) {
      return authModule.user.customer;
    }
  }

  get routeTitle() {
    return this.$route.meta.title.toUpperCase();
  }

  get windowSize() {
    return window.outerWidth;
  }

  openMenu() {
    if (this.windowSize < 1100 && !this.adminNavOpen) {
      this.adminNavOpen = true;
    }
  }

  listSelectChange(selected: ApplicationRecord[]) {
    // selection changed
  }

  logout() {
    authModule.logout();
  }

  @Watch('$route', { immediate: true })
  closeAction() {
    this.adminActionsOpen = false;
  }
}
